import React, { useState, useEffect, ChangeEvent } from "react";
import { User } from "../client";

type FilterProps = {
  users: User[],
  setCurrentUsers: (users: User[]) => void;
  setTotalRecords: (count: number) => void;
  query: string,
  setQuery: (query:string) => void;
  indexOfFirstRecord:number,
  indexOfLastRecord:number
};

const Filter = ({ indexOfFirstRecord, query, users, indexOfLastRecord, setCurrentUsers, setTotalRecords, setQuery}:FilterProps ) => {
  const searchParameters =
    users && Object.keys(Object.assign({}, ...users));

  useEffect(() => {
    const filteredData = users.filter((item: any) =>
      searchParameters.some((parameter:any) =>
        item[parameter].toString().toLowerCase().includes(query)
      )
    );
    if (query !== "") {
      setCurrentUsers(filteredData);
      setTotalRecords(filteredData.length);
    } else {
      setCurrentUsers(users && users.slice(indexOfFirstRecord, indexOfLastRecord));
      setTotalRecords(users.length);
    }
  }, [query, users]);
  const search = (e: ChangeEvent<HTMLInputElement>) => {
    setQuery(e.target.value);

  };
  return (
    <div>
      <input
        type="text"
        placeholder="Search by name, email or role"
        onChange={(e) => search(e)}
        className="w-full p-2 border-2 border-black-500"
      />
    </div>

  )
}

export default Filter;


